import script from "./OtpSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpSignup.vue?vue&type=script&setup=true&lang=js"

import "./OtpSignup.vue?vue&type=style&index=0&id=65a922b9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65a922b9"]])

export default __exports__